import React from 'react';
import './css/App.css';
import { CaseCreator } from './components/CaseCreator';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import logo from './img/welcomeToMilaLogo.png';

function App() {
  // Import the useMsal hook
  const { instance, accounts } = useMsal();

  // Function to handle the login process
  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(e => {
      console.error(e);
    });
  };

  // Function to handle the logout process
  const handleLogout = () => {
    instance.logoutRedirect().catch(e => {
      console.error(e);
    });
  };

  // Return the app UI
  return (
    <div className="App">
      {accounts.length > 0 ? (
        <>
          <header className="app-header">
            <h1>Mila JARVIS - Case Manager</h1>
            <button onClick={handleLogout} className="logout-btn">
              Logout
            </button>
          </header>
          <CaseCreator />
        </>
      ) : (
        <div className="login-container">
          <img src={logo} alt="Logo" style={{ width: '200px', height: '124px' }} />
          <button onClick={handleLogin} className="login-btn">
            Click this button to Log in to Mila
          </button>
        </div>
      )}
    </div>
  );
}

export default App;
